import { render, staticRenderFns } from "./auditComicRemarkEdit.vue?vue&type=template&id=8e44040c&scoped=true"
import script from "./auditComicRemarkEdit.vue?vue&type=script&lang=js"
export * from "./auditComicRemarkEdit.vue?vue&type=script&lang=js"
import style0 from "./auditComicRemarkEdit.vue?vue&type=style&index=0&id=8e44040c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e44040c",
  null
  
)

export default component.exports